import { patientAnswers } from './patient-answers-data';

export const mockPatientAnswersLogsData = {
  currentPatientAnswers: patientAnswers.data[0],
  previousPatientAnswers: [
    {
      status: 'completed',
      retakeCount: 2,
      endedAt: '2021-01-10T10:01:34.891Z',
      updatedAt: '2021-01-10T10:01:34.891Z',
      user: {
        id: 555,
        user_detail: {
          firstName: 'Mister',
          lastName: 'Rogers',
        },
      },
      createdByUser: {
        id: 173,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
      updatedByUser: {
        id: 173,
        user_detail: {
          firstName: 'Test Name',
          lastName: 'Test LastName',
        },
      },
    },
  ],
};
